import { QuestionMarkCircleIcon } from "@heroicons/react/24/outline";
import type { MouseEvent, ReactNode } from "react";
import { classNames } from "../styles/classNames";

interface FieldHelpLinkProps {
  /** The help page, and how it opens: in its own tab, or in place through `onClick`. */
  href: string;
  target?: string;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
  /** The question the article answers, such as "What must the file look like?". */
  children: ReactNode;
  className?: string;
}

/** A small link from a form field to the help article that explains it (web-app.md WA-6). */
export default function FieldHelpLink({ href, target, onClick, children, className }: FieldHelpLinkProps) {
  return (
    <a href={href} target={target} onClick={onClick} className={classNames("app-link inline-flex items-center gap-1 text-xs", className)}>
      <QuestionMarkCircleIcon className="h-4 w-4 shrink-0" aria-hidden="true" />
      {children}
    </a>
  );
}
